import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'

Vue.component('vue-editor', Editor)
Vue.component('vue-editor-toolbar', Toolbar)